function endpoints(builder) {
  return {
    getSearchTranslates: builder.query({
      query: () => 'actions/frontend/search/get-translates',
    }),
  };
}

export { endpoints };
